'use client';

import Image from 'next/image';
import { useRouter } from 'next/navigation';

import { Botao } from '@components';

import * as Styles from './styles';

export const PaginaNaoEncontradaView = () => {
  const rota = useRouter();

  return (
    <>
      <Styles.Global />

      <Styles.Conteiner>
        <Image
          src='/images/logo_governo_flat.svg'
          width={198}
          height={96}
          alt='Logo do Governo do Estado de Mato Grosso do Sul'
        />

        <Image
          src='/images/erro_not_found.svg'
          width={566}
          height={301}
          alt='Ilustração de erro de página não encontrada'
        />

        <Styles.Mensagem>
          <h2>Página não encontrada!</h2>
          <p>Ela pode ter sido excluída ou movida para outro endereço.</p>
        </Styles.Mensagem>

        <Botao id='voltar' texto='Voltar' onClick={() => rota.replace('/')} />
      </Styles.Conteiner>
    </>
  );
};
